export const HealthInsurancePriceSteps = [
  {
    id: 1,
    text: "Insurance Info",
  },
  {
    id: 2,
    text: "Personal Info",
  },
  {
    id: 3,
    text: "Address Info",
  },
  {
    id: 4,
    text: "Confirmation",
  },
];

export const TravelInsurancePriceSteps = [
  {
    id: 1,
    text: "Insurance Info",
  },
  {
    id: 3,
    text: "Confirmation",
  },
];

export const KaskoInsurancePriceSteps = [
  {
    id: 1,
    text: "Insurance Info",
  },
  // {
  //   id: 3,
  //   text: "Confirmation",
  // },
];
export const DaskInsurancePriceSteps = [
  {
    id: 1,
    text: "Insurance Info",
  },
  // {
  //   id: 3,
  //   text: "Address Info",
  // },
  // {
  //   id: 4,
  //   text: "Building Info",
  // },
  {
    id: 5,
    text: "Confirmation",
  },
];

export const TourismInsuranceTypeSteps = [
  {
    id: 1,
    text: "Insurance Info",
  },
  {
    id: 2,
    text: "Address Info",
  },
  {
    id: 3,
    text: "Confirmation",
  },
];

export const TssInsuranceTypeSteps = [
  {
    id: 1,
    text: "Insurance Info",
  },
  {
    id: 2,
    text: "Address Info",
  },
  {
    id: 3,
    text: "Confirmation",
  },
];

export const OssInsuranceTypeSteps = [
  {
    id: 1,
    text: "Insurance Info",
  },
  {
    id: 2,
    text: "Address Info",
  },
  {
    id: 3,
    text: "Confirmation",
  },
];
